
import {
    ButtonColor,
    ButtonSize,
    Icons,
} from '@/enums';
import React, { KeyboardEvent, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Button from './Button';
import strings from '@/language/Swedish';
import useIsMobile from '@/helpers/useIsMobile';
import tw from 'twin.macro';
import { createPortal } from 'react-dom';
const Overlay = styled.div<{$blur?: boolean; $isMobileLandscape?: boolean}>`
${tw`animate-fadeIn`}
${({ $blur }) => ($blur &&  (`backdrop-filter: blur(5px);`))};
position: fixed;
opacity: 0;
top:0px;
left:0px;
width: 100%!important;
height: 100%!important;
z-index: 10000;
padding: 40px;
display: flex;
pointer-events: visible;
  @media only screen and (max-width: 640px) {
 padding: 0px;
}
${({ $isMobileLandscape }) => $isMobileLandscape && `padding: 0px;`}

`;
const Wrapper = styled.div<{ $isMobile?: boolean, $isMobileLandscape?: boolean, $left?:string, $top?: string, $anchor?: string }>`
position: relative;
${({ $anchor }) => ($anchor &&  (`position-anchor:` + $anchor))};
right: anchor(left); //Refactor in future to use in other components
top: anchor(top);
background: white;
padding: 20px;
border-radius: 20px;
pointer-events: all;
overflow: auto;
overflow-y: scroll;
max-height: 100%;
box-shadow: 0px 0px 20px rgba(0,0,0,0.3);
${({ $isMobile }) => $isMobile && `
width: 100%;
left: 0px;
top: 0px;
  height: 100%;
   border-radius: 0px;`
    }
${({ $isMobileLandscape }) => $isMobileLandscape && `
  padding: 10px 12px;
`}
`;

const ClickLayer = styled.div`
position: absolute;
width: 100%;
height: 100%;
`;

const CloseWarapper = styled.div`
position: absolute;
right: 10px;
top: 10px;
`;

interface PopupProps{
    children: React.ReactNode;
    closeSlot?: React.ReactNode;
    isOpen: boolean;
    setIsOpen?: (value: boolean) => void;
    contentPosition?: "center" | "bottom" | "left";
    onClose?: () => void;
    blur?: boolean;
    disabeled?: boolean;
    anchor?: string;
}

export default function Popup({ children, closeSlot, isOpen, setIsOpen, contentPosition = "center", onClose, blur, disabeled, anchor }: PopupProps) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    function close() {
        if (onClose) {
            onClose();
        }
        setIsOpen(false);
    }
    function onKeyDown(e: KeyboardEvent<HTMLImageElement>) {
        if (e.key === "esc" || e.key == "Escape") {
            close();
        }
    }

    const isMobile = useIsMobile();
    useEffect(() => {
        if (wrapperRef.current && isOpen) {
            wrapperRef.current.scrollTop = 0;
        }
    }, [isOpen]);


    function getPosition(position: string) {
        switch (position) {
            case "bottom":
                return { alignItems: "flex-end", justifyContent: "center" }
            case "center":
                return { alignItems: "center", justifyContent: "center" }

        }

    }

    return isOpen ? createPortal(
        <Overlay onKeyDown={onKeyDown} style={getPosition(contentPosition)} $blur={blur}>
            <ClickLayer onClick={() => !disabeled && close()} />
            <Wrapper ref={wrapperRef} $isMobile={isMobile} $anchor={anchor}>
                <CloseWarapper>
                    <div className="flex flex-row bg-white rounded-full border border-grey">
                        {closeSlot}
                        {!closeSlot && !disabeled && (
                            <Button
                                icon={Icons.remove}
                                size={ButtonSize.medium}
                                color={ButtonColor.transparent}
                                onClick={() => {
                                    setIsOpen(false);
                                }}
                            />
                        )}
                    </div>
                </CloseWarapper>
                {children}
                {!disabeled && (
                    <Button
                        size={ButtonSize.large}
                        color={ButtonColor.primary}
                        onClick={close}
                        className='center my-2 float-right'
                    >{strings.dialog.closeWindow}</Button>
                )}
            </Wrapper>
        </Overlay>,
        document.body
    ) : null
}